import {
  createThemes,
  DEFAULT_PALETTE,
  DEFAULT_SUBDUED_PALETTE,
} from '@bsky.app/alf'

const GROOVYVERSE_PRIMARY = {
  primary_25: '#F8F5FF',
  primary_50: '#F1EBFF',
  primary_100: '#E3D7FF',
  primary_200: '#CDB8FF',
  primary_300: '#B28FFF',
  primary_400: '#9568F7',
  primary_500: '#7B4DFF',
  primary_600: '#6938E6',
  primary_700: '#572BC1',
  primary_800: '#46239A',
  primary_900: '#381D78',
  primary_950: '#281354',
  primary_975: '#1B0C3A',
}

const GROOVYVERSE_SUBDUED_PRIMARY = {
  primary_25: '#F8F6FC',
  primary_50: '#F0ECF8',
  primary_100: '#E1D9F1',
  primary_200: '#C8B9E5',
  primary_300: '#AD98D7',
  primary_400: '#9278C7',
  primary_500: '#795FB5',
  primary_600: '#674DA0',
  primary_700: '#563F87',
  primary_800: '#47356F',
  primary_900: '#392B58',
  primary_950: '#2B2043',
  primary_975: '#211833',
}

const GROOVYVERSE_PALETTE = {
  ...DEFAULT_PALETTE,
  ...GROOVYVERSE_PRIMARY,
}

const GROOVYVERSE_SUBDUED_PALETTE = {
  ...DEFAULT_SUBDUED_PALETTE,
  ...GROOVYVERSE_SUBDUED_PRIMARY,
}

const DEFAULT_THEMES = createThemes({
  defaultPalette: GROOVYVERSE_PALETTE,
  subduedPalette: GROOVYVERSE_SUBDUED_PALETTE,
})

export const themes = {
  lightPalette: DEFAULT_THEMES.light.palette,
  darkPalette: DEFAULT_THEMES.dark.palette,
  dimPalette: DEFAULT_THEMES.dim.palette,
  light: DEFAULT_THEMES.light,
  dark: DEFAULT_THEMES.dark,
  dim: DEFAULT_THEMES.dim,
}

export const lightPalette = DEFAULT_THEMES.light.palette
export const darkPalette = DEFAULT_THEMES.dark.palette
export const dimPalette = DEFAULT_THEMES.dim.palette

export const light = DEFAULT_THEMES.light
export const dark = DEFAULT_THEMES.dark
export const dim = DEFAULT_THEMES.dim
